<template>
  <div
    class="w-full min-h-screen flex flex-col space-y-4 items-center justify-center"
  >
    <p class="text-3xl font-bold text-gray-900">Not Found</p>
    <router-link to="/posts">
      <button class="px-6 py-1 border rounded-md">Home</button>
    </router-link>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
